import { TableHeading } from "../../../components/common/table/TableDesign";

const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

/*----------------------------*/
/* Estimate Screen */
/*----------------------------*/
export const leadEstimateChargesHeading: TableHeading[] = [
  { label: "Service" },
  { label: "Service Description", align: "left" },
  { label: "Provisional Date", align: "left" },
  { label: "Price", align: "center" },
];

export const leadEstimateChargesFields = [
  // {
  //   id: "typeName",
  //   type: "staticText",
  // },
  {
    id: "typeName",
    placeHolder: "",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "description",
    placeHolder: "",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "provisionalDate",
    type: "staticText",
    width: "120px",
  },
  {
    id: "price",
    placeholder: "Charge",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 6,
    },
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
  },
];

export const leadEstimateCostHeading: TableHeading[] = [
  { label: "Drivers" },
  { label: "Porters", align: "left" },
  { label: "Packers", align: "left" },
  { label: "Wages", align: "center" },
  { label: "Vehicles", align: "center" },
  { label: "", align: "center" },
  { label: "Fuel", align: "center" },
];

export const leadEstimateCostFields = [
  {
    id: "driverQty",
    placeholder: "Qty",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "porterQty",
    placeholder: "Qty",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "packerQty",
    placeholder: "Qty",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "wageCharge",
    placeholder: "Charge",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "vehicleTypeId",
    placeholder: "",
    type: "select",
    width: "100px",
  },
  {
    id: "vehicleQty",
    placeholder: "Qty",
    type: "text",
    width: "35px",
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "fuelCharge",
    placeholder: "Charge",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
  },
];

export const leadEstimateMaterialsHeading: TableHeading[] = [
  { label: "Materials" },
  // { label: "Surveyed Qty", align: "left" },
  { label: "Charge Qty", align: "left" },
  { label: "Rate", align: "center" },
  { label: "Total", align: "center" },
  // { label: "Volume", align: "center" },
  // { label: "Cost", align: "center" },
];

export const leadEstimateMaterialsFields = [
  {
    id: "name",
    type: "staticText",
  },
  // {
  //   id: "surveyedQty",
  //   placeHolder: "",
  //   type: "text",
  //   width: "100px",
  //   inputProps: {
  //     maxLength: 50,
  //   },
  //   valueFormat: "number",
  //   patternAllowed: patternConstant?.NUMERIC,
  // },
  {
    id: "chargeQty",
    placeHolder: "",
    type: "text",
    width: "120px",
    inputProps: {
      maxLength: 6,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "price",
    placeHolder: "",
    type: "text",
    width: "120px",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "price",
    prefixIcon:'£',
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "total",
    placeHolder: "",
    type: "text",
    width: "120px",
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: "price",
    prefixIcon:'£',
    patternAllowed: patternConstant?.PRICE,
  },
  // {
  //   id: "volume",
  //   placeHolder: "",
  //   type: "text",
  //   width: "50px",
  //   inputProps: {
  //     maxLength: 50,
  //   },
  //   valueFormat: "price",
  //   patternAllowed: patternConstant?.PRICE,
  // },
  // {
  //   id: "cost",
  //   placeHolder: "",
  //   type: "text",
  //   width: "50px",
  //   inputProps: {
  //     maxLength: 50,
  //   },
  //   disabled: true,
  //   valueFormat: "price",
  //   patternAllowed: patternConstant?.PRICE,
  // },
];

export const leadEstimateGenInfoHeading: TableHeading[] = [
  { label: "General Information" },
  { label: "", align: "left" },
];

export const leadEstimateGenInfoFields = [
  {
    id: "generalInformation",
    type: "staticText",
  },
  {
    id: "price",
    placeHolder: "",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 50,
    },
    prefixIcon:'£',
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
  },
];

export const leadEstimateGenInoList = [
  { generalInformation: "Driver wage", price: "", id: "driverWage" },
  { generalInformation: "Porter wage", price: "", id: "porterWage" },
  { generalInformation: "Packer wage", price: "", id: "packerWage" },
  { generalInformation: "Contents Value", price: "", id: "contentsValue" },
];

export const leadEstimateAncillariesHeading: TableHeading[] = [
  { label: "Ancillaries" },
  { label: "", align: "left" },
  { label: "Charageable" },
];

export const leadEstimateAncillariesFields = [
  // {
  //   id: "name",
  //   type: "staticText",
  // },
  {
    id: "name",
    placeHolder: "",
    type: "text",
    width: "60px",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "charge",
    placeHolder: "",
    type: "text",
    width: "60px",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "price",
    prefixIcon:'£',
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "isChargeable",
    placeHolder: "",
    type: "checkbox",
    width: "40px",
  },
];

export const leadEstimateAncillariesList = [
  { ancillaries: "Tolls", price: "", charageable: false },
  { ancillaries: "Ferry charges", price: "", charageable: false },
  { ancillaries: "", price: "", charageable: false },
];

export const leadEstimateNewFinalFields = [
   {
    label: "Amount :",
    type: "title",
    md: 1.5,
  },
  {
    id: "quoteTotal",
    label: {
      quotation: "Quote Total",
      estimate: "Total",
    },
    placeHolder: "",
    type: "text",
    firstColmd: 1.4,
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
     inSingleGridForm: true,
    valueFormat: "price",
    prefixIcon:'£',
    patternAllowed: patternConstant?.PRICE,
  },
  // {
  //   id: "costTotal",
  //   label: {
  //     quotation: "Total Cost",
  //     estimate: "Total Cost",
  //   },
  //   placeHolder: "",
  //   type: "text",
  //   // md: 4,
  //   inputProps: {
  //     maxLength: 50,
  //   },
  //   disabled: true,
  //   valueFormat: "price",
  //   patternAllowed: patternConstant?.PRICE,
  // },
  // {
  //   id: "quoteExpiresOn",
  //   label: {
  //     quotation: "Quote Expires On",
  //     estimate: "Estimate Expires On",
  //   },
  //   placeHolder: "",
  //   type: "date",
  //   disablePast: true,
  //   // md: 4,
  //   inputProps: {
  //     maxLength: 50,
  //   },
  //   patternAllowed: patternConstant?.NUMERIC,
  // },
];

export const leadEstimateInsuranceGeneralFields = [
  {
    id: "insurancePercentage",
    label: "Insurance",
    placeHolder: "",
    type: "text",
    firstColmd: 1.4,
    md: 3.6,
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];
export const leadEstimateInsuranceFields = [
  {
    id: "insuranceAmount",
    label: "Insurance Amount",
    placeHolder: "",
    type: "text",
    // firstColmd: 4,
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: "number",
    prefixIcon:'£',
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "insuranceType",
    label: "Insurance Type",
    placeHolder: "",
    type: "select",
   options:["Move Price", "Contents", "Pack Price", "In to store", "From store", "Fixed", 'Bronze Ext Liability', 'Silver Ext Liability', 'Gold Ext Liability'],
    // firstColmd: 4,
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];

export const leadEstimateNoteFields = [
  {
    id: "notes",
    label: "Notes",
    placeHolder: "",
    type: "textarea",
    md: 10.5,
    minRows: 2,
    inputProps: {
      maxLength: 1000,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];
export const leadEstimateLogsFields = [
  {
    id: "action",
    title: "Input",
    placeHolder: "Insert text",
    type: "text",
    md: 6,
    isMandatory: true,
    inputProps: {
      maxLength: 150,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  // {
  //   id: "follow_up_date",
  //   title: "Follow Up",
  //   placeHolder: "Select",
  //   type: "date",
  //   md: 3,
  //   disablePast: true,
  // },
  {
    id: "action_type",
    title: "Stage",
    placeHolder: "Select",
    type: "select",
    options: ["NEW LEAD", "ESTIMATES", "SURVEY", "QUOTE", "CONFIRMED"],
    md: 3,
  },
  // {
  //   id: "specific_detail",
  //   title: "Tags",
  //   placeHolder: "Select",
  //   type: "select",
  //   options: [
  //     "Not Specific",
  //     "Drop Out",
  //     "Dispute",
  //     "Volume Under",
  //     "Late",
  //     "Breakages",
  //     "Pack Incomplete",
  //     "Missing Items",
  //     "Dismantle / Reassemble",
  //     "Understaffed",
  //     "Wrong Wages",
  //     "Access Issues",
  //   ],
  //   md: 3,
  // },
];
